<template>
  <div  id="main-content">
    <div  id="sub-header" class="layout-full elementor-page-title">
      <div class="meta-header" >
        <!-- Elementor `page-title` location -->
      </div>
    </div>
    <div id="main" role="main" class="vamtam-main layout-full" >
      <div class="page-wrapper">
        <article id="post-189" class="full post-189 page type-page status-publish hentry">
          <div class="page-content clearfix the-content-parent">
            <div data-elementor-type="wp-page" data-elementor-id="189" class="elementor elementor-189" data-elementor-post-type="page">
              <section class="elementor-section elementor-top-section elementor-element elementor-element-30601e0 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="30601e0" data-element_type="section" data-e-type="section">
                <div  class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8b5c81c" data-id="8b5c81c" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-6c9a220 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="6c9a220" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-icon-box-wrapper">
                            <div class="elementor-icon-box-icon">
                              <span  class="elementor-icon">
                                <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
                              </span>
                            </div>
                            <div class="elementor-icon-box-content">
                              <span class="elementor-icon-box-title">
                                <span>Our Experiences</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-36bdad5 elementor-widget elementor-widget-heading" data-id="36bdad5" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h1 class="elementor-heading-title elementor-size-default">Projects</h1>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-9bddbd7 elementor-widget elementor-widget-text-editor" data-id="9bddbd7" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          <p>Building the future of the construction industry, one project at a time.</p>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-33e79e7 vamtam-force-mobile-hr vamtam-tabs-spacing elementor-tabs-view-horizontal elementor-widget elementor-widget-tabs" data-id="33e79e7" data-element_type="widget" data-e-type="widget" data-widget_type="tabs.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-tabs">
                            <div class="elementor-tabs-wrapper" role="tablist">
                              <div
                                v-for="(category, index) in projectStore.categories"
                                :key="index"
                                :id="`elementor-tab-title-544${index+1}`"
                                :class="[
                                  'elementor-tab-title',
                                  'elementor-tab-desktop-title',
                                  activeTab === index ? 'elementor-active' : ''
                                ]"
                                :aria-selected="activeTab === index"
                                :data-tab="index + 1"
                                role="tab"
                                :tabindex="activeTab === index ? 0 : -1"
                                :aria-controls="`elementor-tab-content-544${index+1}`"
                                @click="handleTabClick(index, category)"
                              >{{category.name}}</div>
                            </div>
                            <div class="elementor-tabs-content-wrapper" role="tablist" aria-orientation="vertical">
                              <!-- <div class="elementor-tab-title elementor-tab-mobile-title elementor-active" aria-selected="true" data-tab="1" role="tab" tabindex="0" aria-controls="elementor-tab-content-5441" aria-expanded="false">All</div> -->
                              <div
                                v-for="(cat, idx) in projectStore.categories"
                                :key="idx"
                                :id="`elementor-tab-content-544${idx+1}`"
                                :class="[
                                  'elementor-tab-content',
                                  'elementor-clearfix',
                                  activeTab === idx ? 'elementor-active' : ''
                                ]"
                                :data-tab="idx + 1"
                                role="tabpanel"
                                :aria-labelledby="`elementor-tab-title-544${idx+1}`"
                                :tabindex="activeTab === idx ? 0 : -1"
                                :hidden="activeTab !== idx"
                                :style="{
                                  display: activeTab === idx ? 'block' : 'none'
                                }"
                              >
                                <div data-elementor-type="section" data-elementor-id="6907" class="elementor elementor-6907" data-elementor-post-type="elementor_library">
                                  <section class="elementor-section elementor-top-section elementor-element elementor-element-7afc98a0 elementor-section-full_width elementor-section-height-min-height elementor-section-items-top elementor-section-content-top elementor-section-height-default" data-id="7afc98a0" data-element_type="section" data-e-type="section">
                                    <div class="elementor-container elementor-column-gap-no">
                                      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f4965c0" data-id="f4965c0" data-element_type="column" data-e-type="column">
                                        <div class="elementor-widget-wrap elementor-element-populated">
                                          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-63898ee4 elementor-grid-tablet-3 elementor-grid-3 elementor-grid-mobile-1 elementor-posts--thumbnail-top vamtam-has-title-underline-anim vamtam-has-read-more-theme-style load-more-align-center elementor-widget elementor-widget-posts" data-id="63898ee4" data-element_type="widget" data-e-type="widget" data-settings="{&quot;pagination_type&quot;:&quot;load_more_on_click&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:30,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:35,&quot;sizes&quot;:[]},&quot;vamtam_classic_columns_tablet&quot;:&quot;3&quot;,&quot;vamtam_classic_columns&quot;:&quot;3&quot;,&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;load_more_spinner&quot;:{&quot;value&quot;:&quot;fas fa-spinner&quot;,&quot;library&quot;:&quot;fa-solid&quot;}}" data-widget_type="posts.vamtam_classic">
                                            <div class="elementor-widget-container">
                                              <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid elementor-has-item-ratio" role="list">
                                                <article v-for="proj in projectStore.projects.docs" :key="proj.id" class="elementor-post elementor-grid-item post-6007 post type-post status-publish format-standard has-post-thumbnail hentry category-interior category-projects tag-residential" role="listitem">
                                                  <div class="vamtam-post-thumb-wrap">
                                                    <a class="elementor-post__thumbnail__link" :href="`/projects/details/` + proj.slug" tabindex="-1" >
                                                      <div class="elementor-post__thumbnail">
                                                        <img decoding="async" width="586" height="762" :src="proj.thumbs" class="attachment-full size-full wp-image-281" alt="" :data-lazy-srcset="proj.thumbs + ` 586w, ` + proj.thumbs + ` 231w`" data-lazy-sizes="(max-width: 586px) 100vw, 586px" :data-lazy-src="proj.thumbs" />
                                                        <noscript><img loading="lazy" decoding="async" width="586" height="762" :src="proj.thumbs" class="attachment-full size-full wp-image-281" alt="" :srcset="proj.thumbs + ` 586w, ` + proj.thumbs + ` 231w`" sizes="(max-width: 586px) 100vw, 586px" /></noscript>
                                                      </div>
                                                    </a>
                                                    <div class="vamtam-read-more-wrap">
                                                      <a class="vamtam-read-more-icon" :href="`/projects/details/` + proj.slug">
                                                        <i aria-hidden="true" class="vamtamtheme- vamtam-theme-plus"></i>
                                                      </a>
                                                      <a class="elementor-post__read-more" :href="`/projects/details/` + proj.slug" :aria-label="proj.projectName" tabindex="-1" >
                                                        View Project
                                                      </a>
                                                    </div>
                                                  </div>
                                                  <div class="elementor-post__meta-data">
                                                    <div class="vamtam-post__categories">
                                                      <span class="list-tag">
                                                        <a v-if="proj?.categoryId?.parentId === null" :href="`/our-services/category/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                                                        <a v-else :href="`/our-services/details/` + proj?.categoryId?.parentId?.slug + `/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                                                        
                                                      </span>
                                                      
                                                      
                                                    </div>
                                                  </div>
                                                  <div class="elementor-post__text">
                                                    <h4 class="elementor-post__title">
                                                      <a :href="`/projects/details/` + proj.slug" class="title-project">
                                                        {{ proj.projectName }}
                                                      </a>
                                                    </h4>
                                                  </div>
                                                </article>
                                              </div>
                                              <!-- <div v-if="projectStore.projects.nextPage !== null" class="e-load-more-anchor" :data-page="projectStore.projects.page" :data-max-page="projectStore.projects.totalPages" :data-next-page=""></div>
                                              <div class="elementor-button-wrapper">
                                                <a class="elementor-button elementor-size-sm" role="button">
                                                  <span class="elementor-button-content-wrapper">
                                                    <span class="elementor-button-text">Load More</span>
                                                  </span>
                                                  <span class="e-load-more-spinner">
                                                    <i aria-hidden="true" class="fas fa-spinner"></i>
                                                  </span>
                                                </a>
                                              </div>
                                              <div class="e-load-more-message"></div> -->
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>
      <!-- End of .page-wrapper -->
    </div>
    <!-- #main -->
  </div>
  <!-- #main-content -->
</template>
<script>
  
  import "@/assets/css/widget-tabs.min.css";
  import "@/assets/css/projects.css";

  import { onMounted, ref } from 'vue'
  import { useProjectStore } from '@/stores/projectStore'

  export default {
    name: 'ProjectExperiencesView',
    setup() {
      const projectStore = useProjectStore()
      const activeTab = ref(0)

      onMounted(async () => {
        await projectStore.fetchProjectExperiencePage()
      })

      const handleTabClick = async (index, category) => {
        activeTab.value = index
        console.log(index)
        console.log(category)
        await projectStore.fetchProjectExperiencePage(category._id)
      }

      return {
        projectStore,
        activeTab,
        handleTabClick
      }
    },
    data() {
      return {
        // activeTab: 0
      }
    },
  }
</script>
<style scoped>
  .elementor-kit-5 {
    --e-global-typography-vamtam_h5-font-size-long: 16px;
  }
  .elementor-189 .elementor-element.elementor-element-33e79e7 .elementor-tab-title {
    font-size: var(--e-global-typography-vamtam_h5-font-size-long);
  }

  .elementor-kit-5 h1 {
    font-size: 40px;
  }
  .elementor-kit-5 h2 {
    font-size: 30px;
  }
  .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
  .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title, .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title a {
    font-size: 18px;
  }
</style>